// extracted by mini-css-extract-plugin
export default {"button":"TimerButton_button__5CwUM","timerActive":"TimerButton_timerActive__s1msl","container":"TimerButton_container__G+yq9"};